var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ykc-switch",on:{"click":_vm.handleClick}},[_c('span',{class:_vm.active && 'active',domProps:{"textContent":_vm._s(_vm.text[0])}}),_c('span',{class:!_vm.active && 'active',domProps:{"textContent":_vm._s(_vm.text[1])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }